import React from 'react';
import { Stack, styled } from '@mui/material';
import { FormContainer, ProgressStepper } from '../../components';
import { XeroAuthHeader } from './XeroAuthHeader';
import { XERO_AUTH_STEPS } from './xeroAuthSteps';
import { XERO_COLORS, XERO_NARROW_SCREEN, XERO_SPACING, XERO_THEME_COLOR } from './xeroAuthStyles';

const STEPPER_MAX_WIDTH = '420px';

const XeroAuthCard = styled(FormContainer)`
  padding: 44px 40px;

  @media (max-width: ${XERO_NARROW_SCREEN}) {
    padding: 28px 20px;
  }
`;

const ContentSection = styled(Stack)`
  width: 100%;
  padding-top: ${XERO_SPACING.group};
  border-top: 1px solid ${XERO_COLORS.border};
`;

export const XeroAuthLayout = ({ activeIndex, hasError = false, children }) => (
  <XeroAuthCard>
    <Stack alignItems="center" gap={XERO_SPACING.page}>
      <XeroAuthHeader />
      <Stack width="100%" maxWidth={STEPPER_MAX_WIDTH}>
        <ProgressStepper
          steps={XERO_AUTH_STEPS}
          activeIndex={activeIndex}
          hasError={hasError}
          $themeColor={XERO_THEME_COLOR}
        />
      </Stack>
      <ContentSection>{children}</ContentSection>
    </Stack>
  </XeroAuthCard>
);
